export const DISCORD_INVITE_BADGE = "https://img.shields.io/badge/Discord-Join-738bd7.svg?style=flat-square";
export const DISCORD_INVITE = "https://discord.gg/0SBTUU1wZTYM8nHo";
export const GITHUB_STAR_FRAME = "https://ghbtns.com/github-btn.html?user=zaza7&repo=discordie&type=star&count=true";
export const REPO_ROOT = "https://github.com/zaza7/discordie/tree/master";

export const JS = {
  MDN_PATH: "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/",
  StandardObjects: [
    // Standard objects by category

    // Value properties
    "Infinity",
    "NaN",
    "undefined",
    "null",

    // Fundamental objects
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    "Error",
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError",

    // Numbers and dates
    "Number",
    "Math",
    "Date",

    // Text processing
    "String",
    "RegExp",

    // Indexed collections
    "Array",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",

    // Keyed collections
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",

    // Vector collections
    "SIMD", // experimental
    "Float32x4", // experimental
    "Float64x2", // experimental
    "Int8x16", // experimental
    "Int16x8", // experimental
    "Int32x4", // experimental
    "Uint8x16", // experimental
    "Uint16x8", // experimental
    "Uint32x4", // experimental
    "Bool8x16", // experimental
    "Bool16x8", // experimental
    "Bool32x4", // experimental
    "Bool64x2", // experimental

    // Structured data
    "ArrayBuffer",
    "SharedArrayBuffer", // experimental
    "Atomics", // experimental
    "DataView",
    "JSON",

    // Control abstraction objects
    "Promise",
    "Generator",
    "GeneratorFunction",

    // Reflection
    "Reflect",
    "Proxy",

    // Internationalization
    "Intl",
    "Collator",
    "DateTimeFormat",
    "NumberFormat",

    // Non-standard objects
    "Iterator",
    "ParallelArray",
    "StopIteration"
  ],

  NODE_DOCS_PATH: "https://nodejs.org/api/",
  NodeObjects: {
    "Buffer": "buffer.html",
    "EventEmitter": "events.html",
    "ReadableStream": "stream.html",
    "WritableStream": "stream.html",
    "TransformStream": "stream.html",
    "DuplexStream": "stream.html",
    "PassThroughStream": "stream.html"
  }
};



// WEBPACK FOOTER //
// ./src/Constants.js